import React from 'react'

const PricingPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-white">
      <div className="max-w-4xl mx-auto py-16 px-4">
        <h1 className="text-4xl font-bold text-gray-900 mb-8">Pricing</h1>
        <p className="text-lg text-gray-600">
          Professional AI assistance for your motorcycle maintenance needs.
        </p>
      </div>
    </div>
  )
}

export default PricingPage
